"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OAuthProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const client_oauth2_1 = __importDefault(require("client-oauth2"));
const react_1 = require("react");
const TokenContext_1 = require("../../contexts/TokenContext");
const useAutoLogin_1 = require("../../hooks/useAutoLogin");
const useCodeChallenge_1 = require("../../hooks/useCodeChallenge");
const useOAuthState_1 = require("../../hooks/useOAuthState");
const useTokenFromInterceptedOAuthRedirect_1 = require("../../hooks/useTokenFromInterceptedOAuthRedirect");
const useTokenFromSessionStorage_1 = require("../../hooks/useTokenFromSessionStorage");
const authBaseUrl = 'https://auth.yanzi.cloud/auth';
function OAuthProvider({ children, keyCloakRealm, clientId, }) {
    const accessTokenUri = `${authBaseUrl}/realms/${keyCloakRealm}/protocol/openid-connect/token`;
    const authorizationUri = `${authBaseUrl}/realms/${keyCloakRealm}/protocol/openid-connect/auth`;
    const logoutUrl = react_1.useMemo(() => keyCloakRealm
        ? `${authBaseUrl}/realms/${keyCloakRealm}/protocol/openid-connect/logout?redirect_uri=${window.location.origin}`
        : null, [keyCloakRealm]);
    const oauthClient = react_1.useMemo(() => {
        if (!authorizationUri || !accessTokenUri || !clientId) {
            return null;
        }
        return new client_oauth2_1.default({
            authorizationUri,
            accessTokenUri,
            clientId,
        });
    }, [accessTokenUri, authorizationUri, clientId]);
    const authUrl = useOAuthAuthUrl(keyCloakRealm, oauthClient);
    const { token: tokenFromOAuthRedirect, isIntercepting, error, clear, } = useTokenFromInterceptedOAuthRedirect_1.useTokenFromInterceptedOAuthRedirect(oauthClient, logoutUrl, keyCloakRealm);
    const { token: tokenFromSessionStorage } = useTokenFromSessionStorage_1.useTokenFromSessionStorage(accessTokenUri, clientId, oauthClient);
    const newToken = tokenFromOAuthRedirect !== null && tokenFromOAuthRedirect !== void 0 ? tokenFromOAuthRedirect : tokenFromSessionStorage;
    const [token, setToken] = react_1.useState(newToken);
    react_1.useEffect(() => {
        if (newToken) {
            setToken(newToken);
        }
    }, [newToken]);
    useAutoLogin_1.useAutoLogin(authUrl);
    const [, setRefreshToken] = useTokenFromSessionStorage_1.useRefreshTokenStorage();
    const refreshToken = token === null || token === void 0 ? void 0 : token.refreshToken;
    react_1.useEffect(() => {
        if (refreshToken) {
            setRefreshToken(refreshToken);
        }
    }, [refreshToken, setRefreshToken]);
    const accessToken = react_1.useMemo(() => {
        if (!token)
            return null;
        return {
            get: () => __awaiter(this, void 0, void 0, function* () {
                if (token.expired()) {
                    const newToken = yield token.refresh();
                    setToken(newToken);
                    return newToken === null || newToken === void 0 ? void 0 : newToken.accessToken;
                }
                return token.accessToken;
            }),
        };
    }, [token]);
    const value = react_1.useMemo(() => ({
        authUrl,
        accessToken,
        isIntercepting,
        error,
        clear,
        logoutUrl,
        client: oauthClient,
        clientId,
        accessTokenUri,
    }), [
        isIntercepting,
        accessToken,
        authUrl,
        error,
        clear,
        logoutUrl,
        oauthClient,
        clientId,
        accessTokenUri,
    ]);
    return jsx_runtime_1.jsx(TokenContext_1.TokenContext.Provider, Object.assign({ value: value }, { children: children }), void 0);
}
exports.OAuthProvider = OAuthProvider;
function useOAuthAuthUrl(authRealm, client) {
    const { codeChallenge } = useCodeChallenge_1.useCodeChallenge();
    const state = useOAuthState_1.useCurrentOAuthState(authRealm);
    const authUrl = react_1.useMemo(() => {
        if (!state || !codeChallenge || !client) {
            return null;
        }
        return client.code.getUri({
            redirectUri: window.location.href,
            state,
            query: {
                code_challenge: codeChallenge,
                code_challenge_method: 'S256',
            },
        });
    }, [codeChallenge, client, state]);
    return authUrl;
}
//# sourceMappingURL=index.js.map